import { SquareImage } from '@components/square-image';
import { useScopedTranslate } from '@locale/translate';

import { useFlowNodes } from 'ui/journey-builder/hooks/use-nodes';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

type ActionType = 'webhook';

export const Node = (node: JourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);
  useFlowNodes();

  const integration = node.data.integration;
  const icon = integration?.thumbnail ? <SquareImage src={integration.thumbnail} /> : undefined;

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard
        node={node}
        label={integration?.name ?? t('title')}
        descriptionText={node.data.description || t('description')}
        isConfigured={node.data.isConfigured}
        icon={icon}
      >
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
};

const nodeLocale = {
  en: {
    title: 'Webhook',
    description: 'Wait for incoming webhook',
  },
};
